import { axiosPrivate } from '../../../api/axios';

/**
 * Fetch a single step by its ID
 * @param {string|number} stepId
 * @param {string|number} userId
 * @returns {Promise<Object>} Step data
 */
export const getStepById = async (stepId, userId) => {
  try {
    const response = await axiosPrivate.post(`/steps/${stepId}`, { userId });
    return response.data; // object with step info
  } catch (error) {
    console.error(`❌ Error fetching step with id ${stepId}:`, error);

    // Throw the server response if available, else generic message
    throw error.response?.data || { message: 'Error fetching step.' };
  }
};
